import * as XLSX from 'xlsx';

/**
 * Xuất Excel generic từ 1 mảng object + cấu hình cột.
 * Ví dụ:
 *   exportSheet('Assets', [{code:'TS0001', name:'...'}], [{header:'Mã', key:'code', width:12}, ...])
 */
export interface ColumnDef<T> {
  header: string;
  key: keyof T;
  width?: number;
  format?: (v: unknown, row: T) => string | number;
}

export function exportSheet<T>(
  filename: string,
  rows: T[],
  columns: ColumnDef<T>[],
  sheetName = 'Sheet1',
) {
  const rowsForSheet = rows.map((r) => {
    const out: Record<string, string | number> = {};
    for (const c of columns) {
      const raw = (r as Record<string, unknown>)[c.key as string];
      out[c.header] = c.format ? c.format(raw, r) : (raw as string | number ?? '');
    }
    return out;
  });
  const ws = XLSX.utils.json_to_sheet(rowsForSheet, { header: columns.map((c) => c.header) });
  const cols = columns.map((c) => ({ wch: c.width ?? 15 }));
  (ws as { '!cols'?: unknown[] })['!cols'] = cols;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${filename}-${stamp}.xlsx`);
}

export function fmtDateISO(v: unknown): string {
  if (!v) return '';
  const d = new Date(v as string);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toISOString().slice(0, 10);
}
